<template>
  <div
    class="promo promo-referral-block px-6 lg:px-2 flex flex-col lg:flex-row items-center justify-center tracking-wide text-white"
  >
    <div class="flex items-center justify-center">
      <i class="fa-solid fa-gift" />
      <div class="ml-3 text-sm uppercase font-bold">
        GET 2 EXTRA MONTHS
      </div>
    </div>

    <div class="ml-3 text-sm font-bold text-center lg:text-start">
      Claim your free gift when you subscribe to the Annual plan
    </div>
  </div>
</template>

<script>
import { eventTracker } from '@/utils/eventTracker';
import analyticsEvents from '@/utils/analyticsEvents';

export default {
  mounted() {
    eventTracker(analyticsEvents.headerStripViewed, {
      strip_name: 'refer a friend',
      strip_text: 'GET 2 EXTRA MONTHS  Claim your free gift when you subscribe to the Annual plan',
    });
  },
};
</script>

<style scoped>
.promo {
  background: linear-gradient(270deg, #534CDA 0%, #DE8D98 100%);
  height: 90px;
}
body.overflow-hidden .w-full .promo-referral-block {
  display: none;
}
@screen xl {
  .promo {
    height: 50px;
  }
}
</style>
